import { useState, useEffect } from "react"
import * as S from "./styled"
import { useNavigate } from "react-router-dom"
import Skeleton from "react-loading-skeleton"

interface ImageGalleryProps {
    imagesRef: React.RefObject<HTMLDivElement>
    name: string
    city: string
    accommodationImages: string[],
    isLoading: boolean
}

export const ImageGallery = ({ ...image }: ImageGalleryProps) => {
    const [favorite, setFavorite] = useState(false)
    const [galleryIsOpen, setGalleryIsOpen] = useState(false)
    const [openVisualizer, setOpenVisualizer] = useState(false)
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const navigate = useNavigate()

    const totalImages = image.accommodationImages.length
    const frontImage = image.accommodationImages.slice(0, 5)

    const arrowLeftVisualizer = require('assets/svg/product/ArrowLeftVisualizer.svg').default
    const closedIcon = require('assets/svg/product/ClosedIcon.svg').default
    const galleryIcon = require('assets/svg/product/DotsNine.svg').default
    const firstCaret = require('assets/svg/product/CaretRightGray.svg').default
    const secondCaret = require('assets/svg/product/CaretRightDarkGray.svg').default
    const closeVisualizer = require('assets/svg/product/CloseVisualizer.svg').default

    const [loadedImagesCount, setLoadedImagesCount] = useState(0);
    const [allImagesLoaded, setAllImagesLoaded] = useState(false);

    useEffect(() => {
        let loadedCount = 0;
        const imgElements: HTMLImageElement[] = [];

        image.accommodationImages.forEach((url) => {
            const img = new Image();
            img.src = url;

            img.onload = () => {
                loadedCount++;
                if (loadedCount === image.accommodationImages.length) {
                    setAllImagesLoaded(true);
                }
            };

            imgElements.push(img);
        });

        return () => {
            // Limpa os eventos onload para evitar atualizações de estado em componentes desmontados
            imgElements.forEach((img) => {
                img.onload = null;
            });
        };
    }, [image.accommodationImages]);


    const FavIcon = () => {
        return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.6002 5.5399L12 6.07243L12.3998 5.5399C13.3554 4.26723 14.8975 3.50008 16.6872 3.5C18.0957 3.50166 19.4461 4.06193 20.4421 5.05791C21.4381 6.05396 21.9984 7.40444 22 8.81306C21.9997 11.8601 19.7233 14.6991 17.2536 16.8619C14.8102 19.0017 12.3116 20.3636 12.1214 20.4643L12.1184 20.4659C12.082 20.4855 12.0413 20.4958 12 20.4958C11.9587 20.4958 11.918 20.4855 11.8816 20.4659L11.8786 20.4644C11.6884 20.3636 9.18979 19.0017 6.74637 16.8619C4.27664 14.699 2.00014 11.86 2 8.81277C2.00166 7.40425 2.56193 6.05389 3.55791 5.05791C4.55389 4.06193 5.90425 3.50166 7.31277 3.5C9.10248 3.50008 10.6446 4.26723 11.6002 5.5399Z" fill="#ED374C" stroke="white" />
        </svg>

    }

    const gridStyles = {
        grid0: {
            gridColumn: "3 / span 8",
            gridRow: "1 / 2",
            minWidth: "858px",
            minHeight: '410px',
        },
        grid1: {
            gridColumn: "3 / 7",
            gridRow: "2 / 3",
            minWidth: "421px",
            minHeight: '410px',
        },
        grid2: {
            gridColumn: "7 / span 4",
            gridRow: "2 / 3",
            minWidth: "421px",
            minHeight: '410px',
        },
        grid3: {
            gridColumn: "3 / span 5",
            gridRow: "3 / 5",
            minWidth: "516px",
            minHeight: "618px",
        },
        grid4: {
            gridColumn: "9 / span 2",
            gridRow: "3 / 4",
            minWidth: "324px",
            height: "301px",
        },
        grid5: {
            gridColumn: "9 / span 2",
            gridRow: "4 / 5",
            minWidth: "324px",
            height: "301px",
        },
        grid6: {
            gridColumn: "3 / span 5",
            gridRow: "5 / 7",
            minWidth: "516px",
            minHeight: "618px",
        },
        grid7: {
            gridColumn: "9 / span 2",
            gridRow: "5 / 6",
            minWidth: "324px",
            height: "301px",
        },
        grid8: {
            gridColumn: "9 / span 2",
            gridRow: "6 / 7",
            minWidth: "324px",
            height: "301px",
        }
    };

    function splitIntoParts(arr: any[], maxPartSize: number): any[][] {
        let result: any[][] = [];
        for (let i = 0; i < arr.length; i += maxPartSize) {
            result.push(arr.slice(i, i + maxPartSize));
        }
        return result;
    }

    const imageGroups = splitIntoParts(image.accommodationImages, 9);

    const advanceImage = () => {
        setCurrentImageIndex((currentImageIndex + 1) % image.accommodationImages.length);
    };

    const regressImage = () => {
        setCurrentImageIndex((currentImageIndex - 1 + image.accommodationImages.length) % image.accommodationImages.length);
    };

    return (
        <>
            {image.isLoading ? (<S.Container>
                <Skeleton width={268} height={30} />
                <Skeleton width={461} height={16} style={{
                    marginTop: 4
                }} />
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: '635px calc((277px * 2) + 8px)',
                    gap: 8,
                    marginTop: 8
                }}>
                    <Skeleton width={635} height={390} borderRadius={10} />
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(2,277px)',
                        gridTemplateRows: 'repeat(2,auto-fit)',
                        gap: 8
                    }}
                    > {Array.from({ length: 4 }).map((_, index) => (
                        <Skeleton key={index} width={277} height={189} borderRadius={10} />
                    ))}
                    </div>
                </div>
            </S.Container>

            ) : (
                <S.Container id='Imagens' ref={image.imagesRef}>
                    <S.Title>{image.name}</S.Title>
                    <S.Header>
                        <S.GuideContainer>
                            <S.GuideTextPass onClick={() => navigate('/')}>Inicio</S.GuideTextPass>
                            <img src={firstCaret} alt="" />
                            <S.GuideTextPass>{image.city}</S.GuideTextPass>
                            <img src={secondCaret} alt="" />
                            <S.GuideTextActual>{image.name}</S.GuideTextActual>
                        </S.GuideContainer>
                        {/* <S.FavButton active={favorite} onClick={(e) => setFavorite(!favorite)}>
                    <FavIcon />
                    <p>Favoritar</p>
                </S.FavButton> */}
                    </S.Header>

                    <S.GridImages onClick={() => setGalleryIsOpen(true)}>
                        {frontImage.slice(0, 5).map((image) => {
                            return <S.Image key={image} src={image} alt="" />
                        })}
                    </S.GridImages>

                    <S.ButtonGallery onClick={() => setGalleryIsOpen(true)}><img src={galleryIcon} alt="" /><p>Ver todas as fotos</p> </S.ButtonGallery>
                    {galleryIsOpen &&
                        <S.ModalGallery>
                            <S.ContentGallery>
                                <S.HeaderGallery>
                                    <S.ContentHeader>
                                        <p>Galeria de imagens</p>
                                        <S.ButtonClose onClick={() => setGalleryIsOpen(false)}><img src={closedIcon} alt="" /></S.ButtonClose>
                                    </S.ContentHeader>
                                </S.HeaderGallery>
                                {
                                    allImagesLoaded ? (
                                        <S.GridContainer>
                                            {imageGroups.map((imageGroup, groupIndex) => (
                                                <S.GridGallery key={groupIndex} size={imageGroup.length} >
                                                    {imageGroup.map((image, index) => {
                                                        const totalIndex = groupIndex * 9 + index;
                                                        return <S.ImageGallery
                                                            onClick={() => {
                                                                setOpenVisualizer(true);
                                                                setCurrentImageIndex(totalIndex)
                                                            }} key={image} className={'grid' + index} src={image} alt="" />
                                                    })}
                                                </S.GridGallery>
                                            ))}
                                        </S.GridContainer>
                                    ) : (
                                        <S.GridContainer>
                                            <div style={{
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                gap: '16px',
                                                width: '100%',
                                                alignItems: 'start',
                                                justifyContent: 'center'
                                            }}>
                                                <Skeleton style={gridStyles.grid0} />
                                                <Skeleton style={gridStyles.grid1} />
                                                <Skeleton style={gridStyles.grid2} />
                                                <Skeleton style={gridStyles.grid3} />
                                                <div style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: '16px',
                                                }}>
                                                    <Skeleton style={gridStyles.grid4} />
                                                    <Skeleton style={gridStyles.grid5} />
                                                </div>
                                                <Skeleton style={gridStyles.grid6} />
                                                <div style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: '16px',
                                                }}>
                                                    <Skeleton style={gridStyles.grid7} />
                                                    <Skeleton style={gridStyles.grid8} />
                                                </div>
                                            </div>
                                        </S.GridContainer>
                                    )
                                }

                            </S.ContentGallery>
                        </S.ModalGallery>}
                    {openVisualizer &&
                        <S.ModalVisualizer>
                            <S.ContentVisualizer>
                                <S.HeaderVisualizer>
                                    <S.CloseVisualizer onClick={() => setOpenVisualizer(false)}>
                                        <img src={closeVisualizer} alt="" />
                                    </S.CloseVisualizer>
                                </S.HeaderVisualizer>
                                <S.InteractionVisualizerContainer>
                                    {/*  <S.FavButton active={favorite} visualizer={true} onClick={(e) => setFavorite(!favorite)}>
                                {<FavIcon />}
                                <p>Favoritar</p>
                            </S.FavButton>*/}
                                </S.InteractionVisualizerContainer>
                                <S.VisualizerIndividual>
                                    {image.accommodationImages.map((image: any, index: number) => {
                                        return index === currentImageIndex && <S.ImageVisualizer key={image + index} src={image} alt="" />
                                    })}
                                    <S.DirectionalButtonsContainer>
                                        <S.DirectionalButton direction="left" onClick={regressImage} disabled={currentImageIndex === 0} >
                                            <img src={arrowLeftVisualizer} alt="" />
                                        </S.DirectionalButton>
                                        <S.DirectionalButton direction="right" onClick={advanceImage} disabled={currentImageIndex === image.accommodationImages.length - 1} >
                                            <img src={arrowLeftVisualizer} alt="" />
                                        </S.DirectionalButton>
                                    </S.DirectionalButtonsContainer>
                                </S.VisualizerIndividual>
                                <S.TotalImagesVisualizer>
                                    {image.accommodationImages.map((image: any, index: number) => {
                                        return index === currentImageIndex && <p style={{ color: 'white' }}>
                                            {index + 1} / {totalImages}</p>
                                    })}
                                </S.TotalImagesVisualizer>
                            </S.ContentVisualizer>
                        </S.ModalVisualizer>
                    }
                </S.Container>
            )}

        </>
    )
}